import React from 'react';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';
import './index.css';
import App from './App';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './i18n';
import AdminPanel from './AdminPanel';
import { PrivacyPolicy } from './PrivacyPolicy';
import { IntlProvider } from 'react-intl';

ReactModal.defaultStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position: 'absolute',
    top: '40px',
    left: '40px',
    right: '40px',
    bottom: '40px',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '20px'
  }
}

ReactDOM.render(
  <React.StrictMode>
    <IntlProvider locale="fr">
      <Router>
        <Routes>
          <Route path="/admin" element={<AdminPanel/>}/>
          <Route path="/privacy" element={<PrivacyPolicy />}/>
          <Route path="/*" element={<App/>}/>
        </Routes>
      </Router>
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
